export const toStartOfDay = (ms) => new Date(ms).setHours(0, 0, 0, 0);
export const toEndOfDay = (ms) => new Date(ms).setHours(23, 59, 59, 999);
export const toStartOfHour = (ms) => new Date(ms).setMinutes(0, 0, 0);
export const toEndOfHour = (ms) => new Date(ms).setMinutes(59, 59, 999);
export function getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);
    const oneDay = 1000 * 60 * 60 * 24;
    const diffInTime = date2.getTime() - date1.getTime();
    const diffInDays = Math.round(diffInTime / oneDay);
    return diffInDays;
}
